import { Block, Button, useWizard } from '@mote/ui'
import styled, { css, th } from '@xstyled/styled-components'

export const WizardController = (): JSX.Element => {
  return (
    <Block layout='horizontal' align='center' minHeight={40} gap={24} spreadX>
      <PreviousButton />
      <StepProgress />
    </Block>
  )
}

export interface WizardPreviousButtonProps {
  onClick?: () => void
}

const PreviousButton = (
  props: WizardPreviousButtonProps
): JSX.Element | null => {
  const { canGoToPrevStep, goToPrevStep } = useWizard()

  if (!canGoToPrevStep) return null

  return (
    <Button
      //@ts-expect-error
      size='sm'
      variant='link-secondary'
      onClick={props.onClick ?? goToPrevStep}
      text='Back'
    />
  )
}

export interface WizardFinishButtonProps {
  isLoading?: boolean
  onClick: () => void
}

const FinishButton = (props: WizardFinishButtonProps): JSX.Element => {
  const { isNextDisabled } = useWizard()

  async function handleOnClickNext() {
    await props.onClick()
  }

  return (
    <Button
      //@ts-expect-error
      size='lg'
      text='Get started free'
      disabled={isNextDisabled}
      loading={props.isLoading}
      loadingText='Loading ...'
      onClick={handleOnClickNext}
    />
  )
}

const StepProgress = (): JSX.Element => {
  const { currentStep, totalSteps } = useWizard()

  return (
    <ProgressContainer>
      <Progress index={currentStep} totalSteps={totalSteps + 1} />
    </ProgressContainer>
  )
}

const ProgressContainer = styled.div`
  overflow: hidden;
  width: 100%;
  max-width: 190px;
  background: ${th.color('grey.l3')};
  border-radius: 9px;
`

const Progress = styled.div<{ index: number; totalSteps: number }>`
  height: 8px;
  border-radius: 9px;
  background: ${th.color('blue.l1')};
  transition: width 250ms ease-in;

  width: ${({ index, totalSteps }) =>
    css`calc((${index} * 2 + 1) / ${(totalSteps - 1) * 2} * 100%)`};
`

export const WizardControls = {
  StepProgress,
  PreviousButton,
  FinishButton
}
